{% block moorl_page_detail_smart_bar_actions %}
    {% parent() %}

    <mt-button
        @click="onClickTest"
        :disabled="isNewItem"
        size="default"
        variant="primary"
    >
        {{ $tc('moorl-foundation.button.test') }}
    </mt-button>
{% endblock %}
{% block moorl_page_detail_content %}
    <sw-card-view>
        <mt-card :title="$tc('moorl-client.card.general')">
            <mt-switch
                :label="$tc('moorl-foundation.field.active')"
                v-model="item.active"
            />
            <mt-text-field
                :label="$tc('moorl-foundation.field.name')"
                v-model="item.name"
                required
                validation="required"
            />
            <moorl-select-field
                v-if="options.length"
                :label="$tc('moorl-foundation.field.type')"
                v-model:value="item.type"
                @update:value="resetConfig"
                :customSet="options"
                valueProperty="name"
                labelProperty="name"
            />
        </mt-card>
        <mt-card :title="$tc('moorl-client.card.config')">
            <template v-for="option in options">
                <template v-if="item.type == option.name">
                    <template v-for="config in option.configTemplate">
                        <sw-form-field-renderer
                            v-model:value="item.config[config.name]"
                            :label="$tc('moorl-foundation.field.' + config.name)"
                            :config="config"
                        />
                    </template>
                </template>
            </template>
        </mt-card>
    </sw-card-view>
{% endblock %}